module.exports = __webpack_public_path__ + "img/options-rectangle-start.374febe2.svg";